import { useContext, useState } from 'react'
import Button from '../../../components/Button'
import { PageHeader } from '../../../components/PagesUtilities'
import LayoutContext from '../../../contexts/layout-context'
import {
    controlTabsNational,
    controlTabsInternational,
    storagePage
} from '../storage'
import useSubmit1 from './SectionGeneralInformation/useSubmit1'
import useSubmit4 from './SectionCostDistribution/useSumit4'
import useAutoSave from './useAutoSave'

export default function Header({ cancel }: { cancel: () => void }) {
    let nextText = 'Siguiente'
    let description = ''
    const { open } = useContext(LayoutContext)

    if (storagePage.type === 'international') {
        description =
            '(*) Complete todos los campos para el costeo de importación'
    } else {
        description = '(*) Complete todos los campos para el costeo nacional'
    }
    if (
        (storagePage.type === 'national' &&
            controlTabsNational.value === 'step4') ||
        (storagePage.type === 'international' &&
            controlTabsInternational.value === 'step5')
    ) {
        nextText = 'Guardar'
    }

    if (
        storagePage.mode === 'edition' &&
        controlTabsInternational.value === 'step1'
    ) {
        nextText = 'Guardar'
    }

    const submitStep1 = useSubmit1()
    const submitStep4 = useSubmit4()
    const autoSave = useAutoSave()
    const [isSaving, setIsSaving] = useState(false)

    async function handleClick() {
        // Paso 1: Guardar información general
        if (
            (storagePage.type === 'international' &&
                controlTabsInternational.value === 'step1') ||
            (storagePage.type === 'national' &&
                controlTabsNational.value === 'step1')
        ) {
            submitStep1()
            return
        }

        // Último paso: Guardar y finalizar
        if (
            (storagePage.type === 'national' &&
                controlTabsNational.value === 'step4') ||
            (storagePage.type === 'international' &&
                controlTabsInternational.value === 'step5')
        ) {
            submitStep4()
            return
        }

        // Pasos intermedios: Auto-guardar antes de avanzar
        setIsSaving(true)
        const result = await autoSave(value)
        setIsSaving(false)

        if (result.success || result.skipped) {
            // Avanzar al siguiente paso
            controlTabsInternational.next()
            controlTabsNational.next()

            if (!result.skipped) {
                console.log(
                    '[Header] Cambios guardados automáticamente antes de avanzar'
                )
            }
        } else {
            // Mostrar error pero permitir avanzar
            console.warn(
                '[Header] Auto-guardado falló, pero se permite avanzar'
            )
            controlTabsInternational.next()
            controlTabsNational.next()
        }
    }

    const value =
        storagePage.type === 'international'
            ? controlTabsInternational.value
            : controlTabsNational.value

    function handleCancel() {
        if (value === 'step1' || storagePage.mode === 'edition') {
            cancel()
        } else {
            controlTabsInternational.prev()
            controlTabsNational.prev()
        }
        open()
    }

    return (
        <PageHeader subtitle={description}>
            <Button color="ghost" onClick={handleCancel} disabled={isSaving}>
                {value === 'step1' || storagePage.mode === 'edition'
                    ? 'Cancelar'
                    : 'Volver'}
            </Button>
            <Button
                className="ml-2"
                onClick={handleClick}
                disabled={isSaving}
                loading={isSaving}
            >
                {isSaving ? 'Guardando...' : nextText}
            </Button>
        </PageHeader>
    )
}
